<div class="jumbotron">
  <div class="form-row" style="margin-bottom: 2rem;">
    <div class="col-xl-8 col-lg-8 col-md-8 col-sm-8 col-xs-8">
      <h3>Fire Cadet Academy Application Form -
        <span style="font-weight:300;">Confirmation</span>
      </h3>
    </div>
  </div>
  <form>
    <div class="form-row" style="margin-top: 30px; margin-bottom: 10px;border-bottom:1px solid #d9d9d9;">
      <div class="col-md-12">
        <p style="margin-bottom:1rem;line-height: 1.2rem;text-align: justify;">Thank you for applying to become a FDNY Fire Cadet. The following is a confirmation of your application. A confirmation
          email will be sent to your email address. It is advisable to print and save a copy for your personal records.</p>
      </div>
    </div>
    <div class="form-row">
      <div class="col-md-3 col-sm-3">
        <label for="cadetfirstname" class="labelalign">CONFIRMATION NUMBER:</label>
      </div>
      <div class="col-md-3 col-sm-3">
        <label for="cadetfirstname" class="labelalign valuelabelalign">{{this.applicationConfNumber.conMsg}}</label>
      </div>
    </div>
    <div class="form-row">
      <div class="col-md-3 col-sm-3">
        <label for="cadetfirstname" class="labelalign">FIRST NAME:</label>
      </div>
      <div class="col-md-3 col-sm-3">
        <label for="cadetfirstname" class="labelalign valuelabelalign">{{this.displayCadetData.firstNamePers}}</label>
      </div>
      <div class="col-md-2 col-sm-2">
        <label for="cadetmiddlename" class="labelalign">MIDDLE INITIAL:
        </label>
      </div>
      <div class="col-md-2 col-sm-2">
        <label for="cadetfirstname" class="labelalign valuelabelalign">{{this.displayCadetData.middleNamePers}}</label>
      </div>
    </div>
    <div class="form-row">
      <div class="col-md-3">
        <label for="cadetlastname" class="labelalign">LAST NAME:</label>
      </div>
      <div class="col-md-3 col-sm-3">
        <label for="cadetfirstname" class="labelalign valuelabelalign">{{this.displayCadetData.lastNamePers}}</label>
      </div>
      <div class="col-md-2">
        <label for="cadetmiddlename" class="labelalign">SUFFIX:
        </label>
      </div>
      <div class="col-md-2 col-sm-2 ">
        <label for="cadetfirstname" class="labelalign valuelabelalign">{{this.displayCadetData.suffixNamePers}}</label>
      </div>
    </div>
    <div class="form-row">
      <div class="col-md-3">
        <label for="dateofbirth" class="labelalign">DATE OF BIRTH:</label>
      </div>
      <div class="col-md-4 col-sm-4">
        <label for="cadetfirstname" class="labelalign valuelabelalign">{{this.displayCadetData.dobMonthPers}}-</label>
        <label for="cadetfirstname" class="labelalign valuelabelalign">{{this.displayCadetData.dobDatePers}}-</label>
        <label for="cadetfirstname" class="labelalign valuelabelalign">{{this.displayCadetData.dobYearPers}}</label>
      </div>
    </div>
    <div class="form-row">
      <div class="col-md-3">
        <label for="streetaddr" class="labelalign">MAILING ADDRESS:</label>
      </div>
      <div class="col-md-3 col-sm-4">
        <label for="cadetfirstname" class="labelalign valuelabelalign">{{this.displayCadetData.strtAddrPers}}
          <span style="margin-left:5px;"> {{this.displayCadetData.aptNumPers}} </span>
        </label>
      </div>
    </div>
    <div class="form-row">
      <div class="col-md-3">
        <label for="cityname" class="labelalign">CITY:</label>
      </div>
      <div class="col-md-3 col-sm-4">
        <label for="cadetfirstname" class="labelalign valuelabelalign">{{this.displayCadetData.cityNamePers}}</label>
      </div>

    </div>
    <div class="form-row">
      <div class="col-md-3">
        <label for="statename" class="labelalign">STATE:</label>
      </div>
      <div class="col-md-3 col-sm-4">
        <label for="cadetfirstname" class="labelalign valuelabelalign">{{this.displayCadetData.stateNamePers}}</label>
      </div>
    </div>
    <div class="form-row">
      <div class="col-md-3">
        <label for="zipcodepers" class="labelalign">ZIP CODE:</label>
      </div>
      <div class="col-md-3 col-sm-4">
        <label for="cadetfirstname" class="labelalign valuelabelalign">{{this.displayCadetData.zipCodePers}}</label>
      </div>

    </div>
    <div class="form-row">
      <div class="col-md-3">
        <label for="countrypers" class="labelalign">COUNTRY:</label>
      </div>
      <div class="col-md-3 col-sm-4">
        <label for="cadetfirstname" class="labelalign valuelabelalign">{{this.displayCadetData.countryNamePers}}</label>
      </div>
    </div>
    <div class="form-row">
      <div class="col-md-3">
        <label for="emailpers" class="labelalign">EMAIL ADDRESS:</label>
      </div>
      <div class="col-md-4 col-sm-4">
        <label for="cadetfirstname" class="labelalign valuelabelalign">{{this.displayCadetData.emailAddrPers}}</label>
      </div>
    </div>
    <div class="form-row">
      <div class="col-md-3">
        <label for="cellnumpers" class="labelalign">CELL/PRIMARY NUMBER:</label>
      </div>
      <div class="col-md-3 col-sm-4">
        <label for="cadetfirstname" class="labelalign valuelabelalign">{{this.displayCadetData.cellNumPers}}</label>
      </div>
    </div>
    <div class="form-row">
      <div class="col-md-3">
        <label for="cellnumpers" class="labelalign">APPLICATION DATE:</label>
      </div>
      <div class="col-md-3 col-sm-4">
        <label for="cadetfirstname" class="labelalign valuelabelalign">{{this.applicationDate}}</label>
      </div>
    </div>
    <!-- ############################################# -->
    <div style="height:2rem; background-color: #fff;padding: 0rem;margin:0rem;margin-left: -2rem;
    margin-right: -2rem;">
    </div>

    <div class="jumbotron" style="padding: 0rem;">
      <div class="form-row" style="margin-top: 30px; margin-bottom: 10px;border-bottom:1px solid #d9d9d9;">
        <div class="col-md-12" style="font-weight:900;font-size: 18px;">
          <p style="margin-bottom:0.5rem">PENALTY FOR MISREPRESENTATION</p>
        </div>
      </div>
      <h6 style="text-align: justify;">Any intentional misrepresentation on the application or during the application and appointment process shall result
        in disqualification, even after appointment from the position of Fire Cadet and may result in criminal prosecution.</h6>
      <div class="form-row" style="margin-top: 30px; margin-bottom: 10px;border-bottom:1px solid #d9d9d9;">
        <div class="col-md-12" style="font-weight:900;font-size: 18px;">
          <p style="margin-bottom:0.5rem">CHANGE OF CONTACT INFORMATION</p>
        </div>
      </div>
      <h6 style="text-align: justify;">You are responsible for ensuring the FDNY has your updated contact information. It is critical to promptly notify the
        FDNY of any changes either to your mailing address, email address, or cellular phone number. If your information
        is not kept current, you may not receive time sensitive information pertaining to your application processing, consideration
        for appointment, or information that may require a response by a specified date and time.</h6>
      <h6 style="text-align: justify;">To update your contact information, send an email with a subject titled '<strong>CONFIRMATION NUMBER - Change of Contact Information</strong>'. Your request should include your full name, date
        of birth, previous contact information, and the new contact information. If you have any questions, inquiries, or
        need to update your contact information, please send all emails to <b>FDNY.FireCadet@fdny.nyc.gov</b>.</h6>
    </div>
  </form>
</div>




// WEBPACK FOOTER //
// ./src/app/cadetconfirmationapplication/cadetconfirmationapplication.component.html